import React, { useEffect, useState } from 'react'
import PrecannedQueries from './PrecannedQueries'
import { ExternalLinkIcon } from '@chakra-ui/icons'
import { Box, Link, Button, FormControl, FormLabel, Spinner, Text, Textarea, useToast, VStack, Heading } from '@chakra-ui/react'
import { Link as ReachLink } from "react-router-dom";
import axios from 'axios';
import { TARM_AWS_URL } from '../../api/api';
import DataPoints from './DataPoints';

const NLP2SQL = () => {
    const precannedQueries = [
        {
            "description": "Show me candidates which have experience in Automation Testing and Cucumber",
            "query": "show me candidates name, email, address, file, organization-name, project skills, and years of experience for people who have worked in the organization 'Vodafone Idea Ltd.' and are from Kolkata and have more than 3 years of experience in project skills for 'Data Mining & Management'"
        },
        {
            "description": "Show me candidate which have worked for deloitte and are from Hyderabad",
            "query": "show me candidates name, email,  address, file,  organization-name, project skills, and years of experience for people who have worked in the organization 'Deloitte' and are from 'Hyderabad'"
        },
        {
            "description": "Show me candidates which are SAFE certified",
            "query": "show me candidates name, email, address, file,  organization-name, project skills, certifications and years of experience for people who are SAFE certified"
        }
    ]
    const [source] = useState(axios.CancelToken.source());
    const [isBtnLoading, setIsBtnLoading] = useState(false);
    const [isNoDataFound, setIsNoDataFound] = useState(false);
    const [downloadLink, setDownloadLink] = useState('')
    const [filename, setFileName] = useState('')
    const [query, setQuery] = useState('')
    const toast = useToast();

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(query)
        if (isNoDataFound) setIsNoDataFound(false)
        if (downloadLink) setDownloadLink('')
        genaiSearchHandler(query)
    }


    const genaiSearchHandler = async (query) => {
        try {
            setIsBtnLoading(true)
            const response = await TARM_AWS_URL.post("genai-search", {
                query: query,
            },
                {
                    cancelToken: source.token,
                })
            console.log(response)
            if (response.status === 200) {
                const { data } = response;
                // Check if data is an array and if it is empty
                if (Array.isArray(data) && data.length === 0) {
                    setIsNoDataFound(true);
                } else if (data.presigned_url && data.filename) {
                    // If data contains the necessary properties
                    setFileName(data.filename);
                    setDownloadLink(data.presigned_url);
                }
            }
        } catch (error) {
            console.error(error)
            toast({
                title: error.message,
                status: "error",
                duration: 5000,
                isClosable: true,
            });
        } finally {
            setIsBtnLoading(false)
        }
    }



    useEffect(() => {
        return () => {
            if (source) {
                source.cancel();
            }
        };
    }, []);

    return (
        <VStack>
            <Heading>NLP to SQL</Heading>
            <br />
            <Box width="55%" borderWidth="3px" borderRadius="lg" p="10">
                <form onSubmit={handleSubmit}>
                    <FormControl isRequired>
                        <FormLabel>Drop your query and we will fetch all the maching results using TARM AI</FormLabel>
                        <Textarea
                            value={query}
                            onChange={(e) => setQuery(e.target.value)}
                            placeholder='Start writing your query here...'
                            resize="vertical"
                            height={40}
                            mt={2}
                        />
                    </FormControl>
                    <Box display="flex" justifyContent="space-between" mt="4">
                        <Text fontSize="xs" color="red.500" mt="1">
                            {isNoDataFound ? "No Data Found!" : ""}
                        </Text>
                        <Button
                            type="submit"
                            colorScheme="blue"
                            disabled={!query || isBtnLoading}
                        >
                            {isBtnLoading && <Spinner size="sm" mr={2} />}
                            Submit
                        </Button>
                    </Box>
                </form>
                <Box textAlign="center">
                    {
                        downloadLink &&
                        <Box>
                            <Text>Download results: </Text>
                            <Link color='blue.500' href={downloadLink}>
                                {filename}
                            </Link>
                            <br />
                            <Link
                                color='blue.500'
                                as={ReachLink}
                                to={
                                    '/home/gen-ai/grid/' + filename
                                }
                                isExternal
                            >
                                View results in grid
                                <ExternalLinkIcon mx="5px" />
                            </Link>
                        </Box>
                    }
                </Box>
            </Box>
            <DataPoints />
            <PrecannedQueries precannedQueries={precannedQueries} />
        </VStack>
    )
}

export default NLP2SQL